import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import remarkGfm from 'remark-gfm';

const MarkdownTest = () => {
  const [markdown, setMarkdown] = useState(`# Test Markdown

This is a test of markdown parsing.

\`\`\`python
print("Hello World!")
\`\`\`

And some JavaScript:

\`\`\`javascript
function greet() {
    console.log("Hello!");
}
\`\`\`

Inline code: \`const x = 1;\`
`);

  const markdownComponents = {
    code: ({node, inline, className, children, ...props}) => {
      const match = /language-(\w+)/.exec(className || '');
      console.log('Code component called:', { 
        inline, 
        className, 
        match, 
        children: String(children)
      });
      
      return !inline && match ? (
        <div className="my-4">
          <SyntaxHighlighter
            style={oneDark}
            language={match[1]}
            PreTag="div"
            customStyle={{
              margin: 0,
              borderRadius: '8px',
              fontSize: '14px',
              lineHeight: '1.5',
              fontFamily: 'JetBrains Mono, Consolas, Monaco, monospace',
            }}
            {...props}
          >
            {String(children).replace(/\n$/, '')}
          </SyntaxHighlighter>
        </div>
      ) : (
        <code 
          className={className} 
          style={{
            backgroundColor: '#2d3748',
            color: '#e2e8f0',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '0.9em',
            fontFamily: 'JetBrains Mono, Consolas, Monaco, monospace',
          }}
          {...props}
        >
          {children}
        </code>
      );
    },
  };

  return (
    <div className="p-8 bg-white">
      <h1 className="text-2xl font-bold mb-4">Markdown Test</h1>
      
      <div className="grid grid-cols-2 gap-8">
        <div>
          <h2 className="text-lg font-semibold mb-2">Input (Markdown)</h2>
          <textarea
            value={markdown}
            onChange={(e) => setMarkdown(e.target.value)}
            className="w-full h-96 p-4 border border-gray-300 rounded font-mono text-sm"
            placeholder="Enter markdown here..."
          />
        </div>
        
        <div>
          <h2 className="text-lg font-semibold mb-2">Output (Rendered)</h2>
          <div className="w-full h-96 p-4 border border-gray-300 rounded overflow-auto bg-gray-50">
            <ReactMarkdown 
              components={markdownComponents}
              remarkPlugins={[remarkGfm]}
            >
              {markdown}
            </ReactMarkdown>
          </div>
        </div>
      </div>
      
      <div className="mt-4 p-4 bg-gray-100 rounded">
        <h3 className="font-semibold mb-2">Raw Content:</h3>
        <pre className="text-xs overflow-auto">{markdown}</pre>
      </div>
    </div>
  );
};

export default MarkdownTest; 